// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/services/lotesService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { LoteResumo, CriarLoteRequest, AtualizarLoteRequest, PaginadoResponse } from '../types';

const BASE = '/api/lotes';

export const lotesService = {
  async listar(params: {
    produtoId?: number;
    pagina?: number;
    tamanhoPagina?: number;
    status?: string;
    busca?: string;
    venceEmDias?: number;
    comSaldo?: boolean;
  }): Promise<PaginadoResponse<LoteResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<LoteResumo>>(BASE, { params });
    return data;
  },

  async obterPorId(id: number): Promise<LoteResumo> {
    const { data } = await apiClient.get<LoteResumo>(`${BASE}/${id}`);
    return data;
  },

  async criar(req: CriarLoteRequest): Promise<LoteResumo> {
    const { data } = await apiClient.post<LoteResumo>(BASE, req);
    return data;
  },

  async atualizar(id: number, req: AtualizarLoteRequest): Promise<LoteResumo> {
    const { data } = await apiClient.put<LoteResumo>(`${BASE}/${id}`, req);
    return data;
  },

  async excluir(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
